export const drawerWidth = 310
